import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ReactNode } from "react";
import { useSafeArea } from "./SafeAreaProvider";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  showBack?: boolean;
  backTo?: string;
}

export const PageHeader = ({ 
  title, 
  subtitle, 
  action, 
  showBack = false,
  backTo 
}: PageHeaderProps) => {
  const navigate = useNavigate();
  const { top } = useSafeArea();

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-xl border-b border-border/40"
      style={{ paddingTop: `${top}px` }}
    >
      {/* iOS standard 44px navigation bar */}
      <div 
        className="flex items-center justify-between px-4"
        style={{ height: '44px' }}
      >
        {/* Left: Back + Title */}
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {showBack && (
            <Button 
              variant="ghost" 
              size="icon"
              className="shrink-0 w-11 h-11"
              onClick={() => backTo ? navigate(backTo) : navigate(-1)}
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
          )}
          <div className="min-w-0">
            <h1 className="text-base font-semibold truncate">{title}</h1>
            {subtitle && (
              <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
            )}
          </div>
        </div>

        {/* Right: Action */}
        {action && (
          <div className="shrink-0 ml-2">
            {action}
          </div>
        )}
      </div>
    </div>
  );
};
